export interface ClientDateTimeContextDataPart {
  nowIso: string;
  timezone: string;
  utcOffsetMinutes: number;
  locale: string;
  calendarDate?: string;
}

function padDateSegment(value: number): string {
  return String(value).padStart(2, "0");
}

function toCalendarDate(now: Date): string {
  return [
    now.getFullYear(),
    padDateSegment(now.getMonth() + 1),
    padDateSegment(now.getDate())
  ].join("-");
}

export function buildClientDateTimeContext(): ClientDateTimeContextDataPart {
  const now = new Date();
  const resolved = Intl.DateTimeFormat().resolvedOptions();

  return {
    nowIso: now.toISOString(),
    timezone: resolved.timeZone || "UTC",
    utcOffsetMinutes: -now.getTimezoneOffset(),
    locale: resolved.locale || "en-US",
    calendarDate: toCalendarDate(now)
  };
}
